// extracted by mini-css-extract-plugin
export default {"productFeatured":"o3-z","carousel":"p3-z","slides":"q3-z","slide":"r3-z","slideFeatured":"s3-z","zoomMode":"t3-z","fadeIn":"u3-z","imageSizing":"v3-z"};